selectIsGuideContentSubtype